const login_type = {
  namespaced: true,
  state: {
    register_set: false, // 注册是否已经配置
    login_type: [], // 登录方式
  },
  mutations: {
    set_register_set(state, val) {
      state.register_set = val
    },
    set_login_type(state, val) {
      state.login_type = val
    }
  }
}


export default login_type


// WEBPACK FOOTER //
// ./src/vuex/modules/login_type.js